import Cookies from 'js-cookie';
import type CurrencyCode from '@alltrails/types/CurrencyCode';
import { getPurchaseEventId, getSignupEventId, getTrialStartEventId } from './conversionsApi';
import { marketingConsentEnabled } from './osanoConsent';

// https://businesshelp.snapchat.com/s/article/pixel-direct-implementation?language=en_US
const canTrackEmail = () => marketingConsentEnabled(Cookies.get('at_osano'));

export const trackPurchaseForSnapchat = ({
  currencyCode,
  value,
  isTrial,
  subscriptionEventId,
  emailSha256
}: {
  currencyCode: CurrencyCode;
  value: number;
  isTrial: boolean;
  subscriptionEventId?: number;
  emailSha256?: string | null;
}) => {
  if (isSnapchatPixelUnavailable() || !subscriptionEventId) {
    return;
  }

  if (isTrial) {
    snaptr('track', 'START_TRIAL', {
      currency: currencyCode,
      price: value,
      transaction_id: subscriptionEventId,
      client_dedup_id: getTrialStartEventId(subscriptionEventId),
      user_email: canTrackEmail() ? emailSha256 : undefined
    });
  } else {
    snaptr('track', 'PURCHASE', {
      currency: currencyCode,
      price: value,
      transaction_id: subscriptionEventId,
      client_dedup_id: getPurchaseEventId(subscriptionEventId),
      user_email: canTrackEmail() ? emailSha256 : undefined
    });
  }
};

export const trackCompleteRegistrationForSnapchat = (userId: number, emailSha256?: string | null) => {
  if (isSnapchatPixelUnavailable()) {
    return;
  }

  snaptr('track', 'SIGN_UP', { client_dedup_id: getSignupEventId(userId), user_email: canTrackEmail() ? emailSha256 : undefined });
};

// Check for presence of snaptr in case of content blockers
const isSnapchatPixelUnavailable = () => {
  return typeof snaptr === 'undefined';
};
